import { render, staticRenderFns } from "./fIcon.template?vue&type=template&id=262b3233&lang=pug&"
import script from "./fIcon.client?vue&type=script&lang=ts&"
export * from "./fIcon.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262b3233')) {
      api.createRecord('262b3233', component.options)
    } else {
      api.reload('262b3233', component.options)
    }
    module.hot.accept("./fIcon.template?vue&type=template&id=262b3233&lang=pug&", function () {
      api.rerender('262b3233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fIcon/fIcon.component.vue"
export default component.exports